import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { checkCurrentMemberPassword } from '../services/accountService';
import { useEffect } from 'react';
import { validate, VALIDATOR_REQUIRE } from '../helpers/Validators';
import { VALIDATOR_MATCHING_VALUES } from './../helpers/Validators';
import { Link } from 'react-router-dom';
import usePrepareLink from '../hooks/usePrepareLink';
import { GET_PARAMS, GET_POPUPS } from '../const/router';

export type EditPasswordProps = {
    onSave: (email: string) => void;
    value: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    buttonText: string;
    isEditMode: boolean;
}

const EditPassword: FC<EditPasswordProps> = ({ isEditMode, onSave, value, title, subtitle, buttonText }) => {
    const [oldPassword, setOldPassword] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [matchNewPassword, setMatchNewPassword] = useState<string>("");
    const [errors, setErrors] = useState<any>({});
    const member = useSelector((state: RootState) => state.member);
    const [passwordShown, setPasswordShown] = useState<boolean>(false);



    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };


    const validateForm = () => {
        let errors: any = {};
        if (!validate(oldPassword, [VALIDATOR_REQUIRE()]))
            errors["oldPassword"] = "חובה להזין סיסמה ישנה";
        if (!validate(newPassword, [VALIDATOR_REQUIRE()]))
            errors["newPassword"] = "חובה להזין סיסמה חדשה";
        if (!validate(matchNewPassword, [VALIDATOR_REQUIRE()]))
            errors["matchNewPassword"] = "חובה לחזור על הסיסמה החדשה";
        if (!validate(matchNewPassword, [VALIDATOR_MATCHING_VALUES(newPassword)]))
            errors["matchNewPassword"] = "הסיסמה שהקלדת לא תואמת לסיסמה שלך";

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateWithServer = async () => {
        const { data: passwordCorrect } = await checkCurrentMemberPassword({ memberCode: member.memberCode, password: oldPassword });
        if (!passwordCorrect) {
            let errors: any = {};
            errors["oldPassword"] = "הסיסמה שהקלדת לא תואמת לסיסמה שלך";
            setErrors(errors);
            return false;
        }
        return true;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (validateForm()) {
            if (await validateWithServer()) {
                onSave(newPassword);
            }
            // resgiter.email = email;
            // dispatch(setSignupData(resgiter))
            // props.next()
        }
    };

    const link = usePrepareLink({
        state: {
            navigateFromProfile: true
        },
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.findYourAccount,
        },
        keepOldQuery: true,
    });

    const enabled =
        oldPassword.length > 0 && newPassword.length > 0 && matchNewPassword.length > 0;

    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">{title}</h2>
                    <div>{subtitle}</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form_field_content login">
                            <div style={{ paddingBottom: 5 }} className="field_block"><label htmlFor="oldPassword">סיסמה נוכחית</label>
                                <input autoComplete="off" name="oldPassword" type={passwordShown ? "text" : "password"} value={oldPassword} onChange={e => {
                                    setErrors({})
                                    setOldPassword(e.target.value)
                                }} maxLength={256} className="txt_field password w-input" />
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div className="form_allert" style={{ display: errors && errors["oldPassword"] ? "contents" : "block" }}>{errors["oldPassword"]}</div>
                                    <Link to={link} className="forgot_link">
                                        שכחתי סיסמה
                                    </Link>
                                </div>
                                <div className="field_block">
                                    <label htmlFor="newPassword">בחירת סיסמה חדשה</label>
                                    <input autoComplete="off" name="newPassword" type={passwordShown ? "text" : "password"} value={newPassword} onChange={e => {
                                        setNewPassword(e.target.value)
                                        setErrors({})
                                    }} maxLength={256} className="txt_field password w-input" />
                                    <div className="form_allert" style={{ display: errors && errors["newPassword"] ? "contents" : "block" }}>{errors["newPassword"]}</div>
                                </div>
                                <div className="field_block">
                                    <label htmlFor="matchNewPassword"> הקלדת הסיסמה החדשה פעם נוספת  </label>
                                    <input autoComplete="off" name="matchNewPassword" type={passwordShown ? "text" : "password"} value={matchNewPassword} onChange={e => {
                                        setErrors({})
                                        setMatchNewPassword(e.target.value)
                                    }} maxLength={256} className="txt_field password w-input" />
                                    <div className="form_allert" style={{ display: errors && errors["matchNewPassword"] ? "contents" : "block" }}>{errors["matchNewPassword"]}</div>
                                </div>
                            </div>
                            <div className="form_buttons_group check">
                                <label className="w-checkbox checkbox_field w-clearfix">
                                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox"></div>
                                    <input autoComplete="off" type="checkbox" onChange={togglePasswordVisiblity}
                                        id="checkbox" name="checkbox" data-name="Checkbox" style={{ opacity: 0, position: "absolute", zIndex: -1 }} />
                                    <span className="checkbox_label w-form-label">הצגת סיסמה</span>
                                </label>
                            </div>
                            <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default EditPassword;